import { render, staticRenderFns } from "./chat-box-private.vue?vue&type=template&id=172c85f8&scoped=true"
import script from "./chat-box-private.vue?vue&type=script&lang=js"
export * from "./chat-box-private.vue?vue&type=script&lang=js"
import style0 from "./chat-box-private.vue?vue&type=style&index=0&id=172c85f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c85f8",
  null
  
)

export default component.exports